import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import {
  IContextualMenuItemProps,
  IContextualMenuItemStyleProps,
  IContextualMenuItemStyles,
} from '/druid/ContextualMenuItem.types';
import { ContextualMenuItemBase } from '/druid/ContextualMenuItem.base';
import { getItemStyles } from '/druid/ContextualMenu.classNames';

/**
 * ContextualMenuItem description
 */
export const ContextualMenuItem: React.FunctionComponent<IContextualMenuItemProps> = styled<
  IContextualMenuItemProps,
  IContextualMenuItemStyleProps,
  IContextualMenuItemStyles
>(ContextualMenuItemBase, getItemStyles, undefined, { scope: 'ContextualMenuItem' });
